import { baseApi } from "common/redux/core/api.base";
import { SearchHubService } from "../../services/search-hub.service";
import {
  HybridSearchRequest,
  SearchResultsPayload,
  HybridKgRequest,
  HybridKgResponse
} from "../../models/search-hub.model";

const searchApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    hybridSearch: build.query<SearchResultsPayload, HybridSearchRequest>({
      queryFn: (request) => SearchHubService.hybridSearch(request),
      providesTags: ["SEARCH_RESULTS"]
    }),
    hybridKg: build.query<HybridKgResponse, HybridKgRequest>({
      queryFn: (request) => SearchHubService.hybridKg(request),
      providesTags: ["SEARCH_RESULTS"]
    })
  })
});

export const {
  useHybridSearchQuery,
  useLazyHybridSearchQuery,
  useHybridKgQuery,
  useLazyHybridKgQuery
} = searchApi;
